import { render, staticRenderFns } from "./remove.vue?vue&type=template&id=c035c030"
import script from "./remove.vue?vue&type=script&lang=js"
export * from "./remove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports